import { Paper, CircularProgress } from "@material-ui/core";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSharedVideoActivity } from "../../../../Redux/Actions/ActivityHistoryAction";
import SharedVideoDetails from "./SharedVideoDetails";

const SharedVideos = () => {
  const activityHistoryData = useSelector((state) => state.activityHistoryData);
  const dispatch = useDispatch();

  useEffect(() => {
    getSharedVideoActivity(dispatch, {
      pageNumber: activityHistoryData?.pageNumber,
      status: true,
    });
  }, []);

  const convertArrToString = (name) => {
    let sharedTo = [];
    if (name !== null) {
      const coachesNames = name.filter((item) => item?.firstName != null);
      sharedTo = coachesNames.map((item) => item?.firstName);
      return String(sharedTo).replaceAll(",", ", ");
    }
    return sharedTo;
  };

  const listInnerRef = useRef();

  const onScroll = () => {
    if (
      activityHistoryData?.pageNumber <= activityHistoryData?.totalPages - 1 &&
      !activityHistoryData?.loading
    ) {
      if (listInnerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
        if (Math.round(scrollTop + 1 + clientHeight) >= scrollHeight) {
          getSharedVideoActivity(dispatch, {
            pageNumber: activityHistoryData?.pageNumber,
            status: false,
          });
        }
      }
    }
  };

  return (
    <div className="position-relative">
      <div
        className="height-350 overflow-y"
        onScroll={() => onScroll()}
        ref={listInnerRef}
      >
        {activityHistoryData?.activityData?.videoShared?.map((item) => (
          <div className="main-card-box pd-10 brd-grey" key={item.id}>
            <div className="row pad-bottom-10  brderbtm">
              <div className="d-flex-space-between flex-wrap w-100">
                {item?.groupShare && item?.groupShare.length > 0 ? (
                  <p className="fs-16 semi-bold">
                    {`${
                      item?.shareBy?.firstName
                    } Shared Video To ${item?.groupShare
                      .toString()
                      .replaceAll(",", ", ")}`}
                  </p>
                ) : (
                  <p className="fs-16 semi-bold">
                    {item?.shareBy?.firstName} shared video to{" "}
                    {convertArrToString(item?.coachShare)}
                    {item?.athleteShare && item?.coachShare.length > 0 && ", "}
                    {convertArrToString(item?.athleteShare)}
                  </p>
                )}
                <div>
                  <span className="semi-bold">{item?.lastSeen}</span>
                </div>
              </div>
            </div>
            <SharedVideoDetails item={item} />
          </div>
        ))}

        {!activityHistoryData?.loading &&
          !activityHistoryData?.error &&
          activityHistoryData?.activityData?.videoShared?.length == 0 && (
            <Paper className="activity-trending-container2  pd-10 mg-top-10">
              <p className="nodatabox">
                No feed available currently. Once you or your Coaches, Athletes
                share the content, it will become available here
              </p>
            </Paper>
          )}

        {!activityHistoryData?.loading && activityHistoryData?.error && (
          <p className="nodatabox">
            <Paper className="activity-trending-container2  pd-10 mg-top-10">
              <p className="nodatabox">{activityHistoryData?.error?.message}</p>
            </Paper>
          </p>
        )}
      </div>
      <div
        className="activity-history-loading-container"
        hidden={!activityHistoryData?.loading}
      >
        <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
          <CircularProgress
            className="rounded-circle"
            color="success"
            sx={{ fontSize: 10, color: "#002244" }}
            disableShrink
          />
        </div>
      </div>
    </div>
  );
};

export default SharedVideos;
